(function($, Drupal, drupalSettings) {

  'use strict';

  function mediaqueryresponse(breakpoint){
    if (window.matchMedia(breakpoint).matches) {
      $('body').addClass('js-mobile');
      $('.l-header-right').hide();
    } else {
      $('body').removeClass('js-mobile');
      $(".mobile-menu-btn").removeClass('menu-opened');
      $('.l-header-right').show().removeClass("opened");
    }
  }

  /**
   * Mobile menu
   */
  Drupal.behaviors.defenderMobileMenu = {
    attach: function(context) {
      var mobButton = $(".mobile-menu-btn");
      var mobMenu = $(".l-header-right");
      var mobBreakpoint = "(max-width: " + drupalSettings.menu_mobile_breakpoint + ")";

      mobButton.click(function() {
        $(this).toggleClass("menu-opened");
        mobMenu.toggle().toggleClass("opened");
      });

      if (window.matchMedia('only screen').matches) {
        window.matchMedia(mobBreakpoint).addListener(function(){
          mediaqueryresponse(mobBreakpoint);
        });
      }
      // initial call
      mediaqueryresponse(mobBreakpoint);
    }
  };

  Drupal.behaviors.defenderFilter = {
    attach: function (context) {

      once('defenderFilter-button', '.l-filter-top', context).forEach((el) => {
        el.addEventListener('click', function () {
          $(this).parent().toggleClass('opened');
        });
      });

    }
  };

  /**
   * Contacts
   */
  Drupal.behaviors.defenderContacts = {
    attach: function (context) {

      // Handle timesBtn
      once(
        'defenderContacts-timesBtn',
        '.field--name-field-work-schedule .field__label, .field--name-field-visiting-times .field__label',
        context
      ).forEach((el) => {
        el.addEventListener('click', function () {
          $(this).parent().toggleClass('opened');
        });
      });

      // Handle units
      once(
        'defenderContacts-unit',
        '.view-display-id-units .views-field-name',
        context
      ).forEach((el) => {
        const parent = el.parentElement;
        if (parent.querySelector('.views-row')) {
          parent.classList.add('has-child');
        }
        el.querySelectorAll('.toggler').forEach((toggler) => {
          toggler.addEventListener('click', function () {
            const row = el.closest('.views-row');
            if (row) {
              row.classList.toggle('expanded');
            }
          });
        });
      });

    }
  };

  Drupal.behaviors.defenderFooterMenu = {
    attach: function(context) {

      var orgButton = $(".organization-menu-title");
      var footerMenuWrapper = $(".organization-menu-content");
      var footerMenuHeader = $(".organization-header");

      orgButton.click(function() {
        footerMenuWrapper.toggle();
        $(this).toggleClass("opened");
        footerMenuHeader.toggleClass("opened");
        footerMenuWrapper.toggleClass("opened");
        $('html, body').animate({scrollTop:$(document).height()}, 'slow');
      });

    }
  };

  Drupal.behaviors.backtotopTweak = {
    attach: function(context, settings) {
      var exist = $('#backtotop').length;
      if (exist > 0) {
        checkBTT();
        $(window).scroll(function () {
          checkBTT();
        });
      }
      function checkBTT() {
        if ($(window).scrollTop() > settings.back_to_top.back_to_top_button_trigger) {
          $("body").addClass("btt-visible");
        } else {
          $("body").removeClass("btt-visible");
        }
      }
    }
  };

})(jQuery, Drupal, drupalSettings);
